<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type="" effect="light" expand></base-nav>
  </header>
</template>
<script>
  import BaseNav from "@/components/BaseNav";

  export default {
    components: {
      BaseNav,
    }
  };
</script>
<style>
</style>
